<div class="cell-text-wrapper">
  <div *ngIf="getDateUI() as date" [title]="date" class="text-ellipsis">{{date}}</div>
</div>
